<template>
  <section>
    <div class="mapDetailList">
      <div class="mapDetailListSr">
        <template v-if="list.length > 0">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="mapDetalItem"
            @click="onToCrmDetail(item)"
          >
            <div class="mapDetalItemL">
              <template v-if="item.avatar.real_path">
                <van-image
                  fit="cover"
                  width="70"
                  height="70"
                  :src="item.avatar.real_path"
                />
              </template>
              <template v-else>
                <van-image fit="cover" width="70" height="70" :src="vanImg" />
              </template>
            </div>
            <div class="mapDetalItemR">
              <p class="p1">{{ item.name }}</p>
              <p class="p3">{{ item.contactname }}</p>
              <p class="p3">
                <span>电话：{{ item.contacttel }}</span>
                <span>{{ item.lev4 }}</span>
              </p>
            </div>
          </div>
          <div v-if="loadEnd">
            <p class="pt15 pb15 laodEndText">没有更多内容啦~</p>
          </div>
        </template>
        <template v-else>
          <div class="tc">
            <img width="80%" src="./assets/img/emptyData.png" />
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
import BetterScroll from "better-scroll";

export default {
  name: "test",
  data() {
    return {
      list: [],
      listparam: {
        code: "",
        type: "",
        page: 1,
        page_size: 20
      },
      bs: null,
      disSrool: false,
      loadEnd: false,
      loading: false,
      queryType: 0,
      vanImg: require("./assets/img/avatar.png")
    };
  },
  components: {},
  async mounted() {
    await this.getListData();
    setTimeout(() => {
      this.bs = new BetterScroll(".mapDetailList", {
        scrollY: true,
        pullUpLoad: true,
        click: true,
        mouseWheel: true
      });
      this.bs.on("scroll", async pos => {
        // console.log(pos,this.bs);
        let top = this.bs.scrollerHeight + pos.y - this.bs.wrapper.offsetHeight;
        if (top < 90 && !this.disSrool && !this.loading) {
          this.listparam.page = this.listparam.page + 1;
          await this.getListData();
          this.bs.refresh();
        }
      });
    }, 100);
  },
  methods: {
    onToCrmDetail(item) {
      localStorage.setItem(
        "agentBaseInfo",
        JSON.stringify({
          address: item.address,
          avatar: item.avatar,
          contactname: item.contactname,
          name: item.name
        })
      );
      // location.href = 'http://localhost:9010/#/agentInfoDetail?id=' + item.id;
      location.href = "/jlbwx/index.html#/agentInfoDetail?id=" + item.id;
    },
    getListData() {
      return new Promise(resolve => {
        this.loading = true;
        let url = "/wxapi/order/list_active_by_type";
        if (this.queryType === 1) {
          url = "/wxapi/distributor/list_by_adcode";
        }
        this.$common
          .http({
            mt: "post",
            url: url,
            data: this.listparam
          })
          .then(res => {
            this.loading = false;
            this.list = this.list.concat(res.data.data.items);
            if (res.data.data.items.length < this.listparam.page_size) {
              this.disSrool = true;
              this.loadEnd = true;
            } else {
              this.disSrool = false;
              this.loadEnd = false;
            }
            resolve(res);
          });
      });
    }
  },
  created() {
    this.listparam.code = this.$route.query.code;
    this.listparam.type = this.$route.query.type || "";
    this.queryType = this.$route.query.queryType || 0;
  }
};
</script>
<style lang="less" scope>
.mapDetailList {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  top: 0;
  left: 0;
  .mapDetalItem {
    margin-top: 10px;
    background-color: #fff;
    padding: 10px 15px;
    .mapDetalItemL {
      display: inline-block;
      margin-right: 5px;
    }
    .mapDetalItemR {
      display: inline-block;
      width: calc(100% - 85px);
      vertical-align: top;
      .p1 {
        font-size: 14px;
        color: #333333;
        padding: 5px 0;
      }
      .p3 {
        font-size: 10px;
        color: #7f7f7f;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .laodEndText {
    color: #969799;
    font-size: 14px;
    text-align: center;
  }
}
</style>
